import React, { useState, useEffect } from "react";
import "./HomePage.scss";
import { useNavigate } from "react-router-dom";

interface IPROPS {
    setIsCartOpen: any;
    setOpenVehicleModal: any;
    vehicleData: any;
    fetchVehicle: any;
    setOpenModal: any;
    bannersData: any;
}

const Hero: React.FC<IPROPS> = ({
    bannersData,
    setIsCartOpen,
    setOpenVehicleModal,
    vehicleData,
    fetchVehicle,
    setOpenModal,
}) => {
    const [isMobileWidth, setIsMobileWidth] = useState(
        typeof window !== 'undefined' ? window.innerWidth < 768 : false
    );
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isHovered, setIsHovered] = useState(false);
    const total = bannersData.length;
    const navigate = useNavigate();

    const goToIndex = (index: number) => {
        setCurrentIndex(index);
    };

    const nextImage = () => {
        setCurrentIndex((prev) => (prev + 1) % total);
    };

    const prevImage = () => {
        setCurrentIndex((prev) => (prev - 1 + total) % total);
    };

    // Auto-slide every 8 seconds (pause on hover)
    useEffect(() => {
        if (isHovered) return;

        const interval = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % total);
        }, 10000);

        return () => clearInterval(interval);
    }, [total, isHovered]);

    useEffect(() => {
        const handleResize = () => setIsMobileWidth(window.innerWidth < 768);
        handleResize(); // Run once on mount for correct device emulation
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const token = localStorage.getItem("customer-token");

    const bookNowModal = () => {
        if (!token) {
            setOpenModal("login");
            return;
        } else if (token && vehicleData.length === 0) {
            setOpenVehicleModal(true);
            return;
        } else {
            navigate("/vehicle/select");
        }
    };
console.log(isMobileWidth,"isMobileWidth")
    return (
        <div
            className="hero-carousel"
            style={{ width: "100%" }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <div className="arrow left" onClick={prevImage}>
                <i className="bi bi-chevron-left"></i>
            </div>

            

            <div className="slider-wrapper">
                <div
                    className="slider"
                    style={{ transform: `translateX(-${currentIndex * 100}%)` }}
                >
                    {bannersData?.map((img: any, idx: number) => (
                        <div className="slide" key={idx}>
                            <div style={{ position: 'relative' }}>
                                <img
                                    onClick={bookNowModal}
                                    src={isMobileWidth ? img?.image : img?.web_image}
                                    alt={`slide-${idx}`}
                                    style={{ width: '100%', display: 'block', cursor: 'pointer' }}
                                    onMouseMove={(e) => {
                                        const tooltip = e.currentTarget.parentElement?.querySelector('.tooltip') as HTMLElement;
                                        if (tooltip) {
                                            tooltip.style.opacity = '1';
                                            tooltip.style.left = `${e.nativeEvent.offsetX}px`;
                                            tooltip.style.top = `${e.nativeEvent.offsetY + 20}px`;
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        const tooltip = e.currentTarget.parentElement?.querySelector('.tooltip') as HTMLElement;
                                        if (tooltip) tooltip.style.opacity = '0';
                                    }}
                                />
                                <div className="tooltip" style={{
                                    position: 'absolute',
                                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                    color: 'white',
                                    padding: '5px 10px',
                                    borderRadius: '4px',
                                    fontSize: '14px',
                                    whiteSpace: 'nowrap',
                                    opacity: 0,
                                    transition: 'opacity 0.1s, left 0.1s, top 0.1s',
                                    pointerEvents: 'none',
                                    zIndex: 1,
                                    transform: 'translate(-50%, 0)',
                                    cursor: 'default'
                                }}>
                                    Click to book a service
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="arrow right" onClick={nextImage}>
                <i className="bi bi-chevron-right"></i>
            </div>

            <div className="progress-bar">
                <div className="track">
                    {bannersData.map((_: any, index: number) => (
                        <div
                            key={index}
                            className={`step ${currentIndex === index ? "active" : ""}`}
                            onClick={() => goToIndex(index)}
                        ></div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Hero;
